/**
 * @license
 * Copyright 2018 Google Inc.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

 import './export_image_dialog.less';
 import { Overlay } from 'neuroglancer/overlay';
 import { Viewer } from 'neuroglancer/viewer';
 import { SliceViewPanel } from 'neuroglancer/sliceview/panel';
 import { PerspectivePanel } from 'neuroglancer/perspective_view/panel';
 import { registerEventListener } from 'neuroglancer/util/disposable';
 import html2canvas from 'html2canvas';
 import {mat4, vec2, vec3} from "gl-matrix";
 import {viewer} from "../../main";
 import {makeScaleBarTexture} from "neuroglancer/widget/scale_bar";
import i18n from '../i18n/i18n';
 export class ExportImageDialog extends Overlay {
   imgDom: HTMLImageElement = new Image();
   a: any = document.createElement('a');
   imageNumRadioVal: string = 'all';
   imageSizeRadioVal: string = 'part';
   imgSrcArr: string[] = []; //用于imgDom的src
   panels: any[] = [];
   positionArr: Float32Array[] = [];
   canMove: boolean = false;
   unbindFn: any = undefined;
   ii: number;
   jj: number;
   width: number;
   height: number;
   exportImgSize: number[];
   oldState: any = undefined;
   loadingContainer: HTMLElement = document.createElement('div');
   loadingEle: HTMLElement = document.createElement('div');
   canvas = document.createElement('canvas');
   ctx = this.canvas.getContext('2d');
   imageName: string;
   isQuit: boolean = false;
   preIsBinsizeAuto: boolean = false;//记录打开导出图片面板时，自动切换binSize的状态，导出高清图时需要关闭自动切换斌Size功能。完成后再恢复
   isXy: boolean;
   currentIndex: number = 0;
   hasColorBar: boolean = false;
   colorBarCanvas: HTMLCanvasElement;
   hasLegend: boolean = false;
   private rotateByCurrentCenterMatrix: mat4;//绕当前中心旋转的旋转矩阵，旋转角度为相机z轴夹角，当相机旋转时，导出局部图片需要先将局部的中心点旋转过去
   umapPanel?: SliceViewPanel | undefined;
   private scaleBarTexture: { canvas: HTMLCanvasElement; width: number; height: number };

   constructor(public viewer: Viewer) {
     super();
     const _this = this;
     viewer.display.panels.forEach((item) => {
       if ((item instanceof SliceViewPanel) || (item instanceof PerspectivePanel)) {
         this.panels.push(item);
         if (item instanceof SliceViewPanel && item.sliceView.panelType === "UMAP") {
           this.umapPanel = item;
         }
       }
     })

     let oldState = this.oldState = viewer.state.toJSON();
     oldState.showScaleBar = viewer.showScaleBar.value;
     this.isXy = (typeof oldState.layout === 'object' && oldState.layout.type === 'xy') || (typeof oldState.layout === 'string' && oldState.layout === 'xy');

     let scalebarDom = document.querySelector(".neuroglancer-viewer-scalebar");
     let colorBarStyle = scalebarDom ? getComputedStyle(scalebarDom) : false;
     this.hasColorBar = colorBarStyle && (colorBarStyle.display === 'block') && (parseFloat(colorBarStyle.width) > 0);
     let legendDom = document.querySelector(".neuroglancer-viewer-legend-item");
     let legendStyle = legendDom ? getComputedStyle(legendDom) : false;
     this.hasLegend = legendStyle && (legendStyle.display === 'block') && (parseFloat(legendStyle.width) > 0);
     this.initDom();
     this.preIsBinsizeAuto = viewer.isBinsizeAuto.value;
     {
       //宽高减1是为了兼容有的计算机平台出现网格线的情况
       this.width = this.panels[0].element.clientWidth - 1;
       this.height = this.panels[0].element.clientHeight - 1;
       let commonFn = () => {
         this.canvas.width = this.width;
         this.canvas.height = this.height;
         this.panels.forEach(val => {
           this.canvasToBlob(this.width, this.height, viewer.display.canvas, val)
         })
       };
       if (this.panels.length > 1) {
         let width, height;
         if (this.panels.length === 2) {
           width = this.canvas.width = this.width * 2;
           height = this.canvas.height = this.height;
         } else {
           width = this.canvas.width = this.width * 2;
           height = this.canvas.height = this.height * 2;
         }
         this.canvasToBlob(width, height, viewer.display.canvas, this.panels[0], () => {
           commonFn();
         });
       } else {
         commonFn();
       }
     }

     {
      //  const imageNumRadioArr: any = this.content.querySelectorAll(".img_container input[type=radio]");
      //  imageNumRadioArr[0].checked = true;
      //  for (var i = 0, len = imageNumRadioArr.length; i < len; i++) {
      //    imageNumRadioArr[i].onchange = function () {
      //      _this.imageNumRadioVal = this.value;
      //      _this.imgDom.src = _this.imgSrcArr[this.value === 'all' ? 0 : + (this.value) + 1];
      //    }
      //  }

       const imageSizeRadioArr: any = this.content.querySelectorAll(".row input[type=radio]");
       imageSizeRadioArr[0].checked = true;
       for (var i = 0, len = imageSizeRadioArr.length; i < len; i++) {
         imageSizeRadioArr[i].onchange = function () {
           _this.imageSizeRadioVal = this.value;
         }
       }
     }

     registerEventListener(this.content.getElementsByClassName("export_image_btn")[0], 'click', () => this.exportImg())
     this.content.appendChild(this.buttonClose);
     this.registerEventListener(this.buttonClose, 'click', () => {
       this.dispose();
     });
   }

   saveBlob(url: string, fileName: string) {
     this.a.href = url;
     this.a.download = fileName;
     this.a.click();
   };
   //获取绕当前中心位置旋转的矩阵
   getRotateByCurrentCenterMatrix() {
     let center = this.viewer.position.value;
     let resultMatrix = mat4.create();
     //反向平移，将中心点移动到原点
     mat4.fromTranslation(resultMatrix, vec3.fromValues(-center[0], -center[1], 0));
     let rotateMat4 = mat4.fromQuat(mat4.create(), this.viewer.navigationState.pose.orientation.orientation);//获取相机旋转矩阵
     mat4.multiply(resultMatrix, rotateMat4, resultMatrix);//将当前中心点移动到原点后，计算旋转
     mat4.multiply(resultMatrix, mat4.fromTranslation(mat4.create(), vec3.fromValues(center[0], center[1],0)), resultMatrix);//旋转后再将原来的中心点正向平移到之前的位置
     this.rotateByCurrentCenterMatrix = resultMatrix;
   }
   //导出图片
   exportImg() {
     let viewer = this.viewer;
     let oldState = this.oldState;
     let scale: number = oldState.crossSectionScale;
     if (this.imgSrcArr.length === 1) this.imageNumRadioVal = '0';
     this.imageName = (<any>this.content.querySelector(".file_name")).value;
     this.imageName = this.imageName ? this.imageName : 'image';

     this.getRotateByCurrentCenterMatrix();

     if (this.imageSizeRadioVal === 'part') {
       this.exportPartImg(scale);
     } else {
       (<any>document.querySelector("#neuroglancer-container")).className = "neuroglancer-container";
       let max = Math.max(this.width, this.height);
       if (max * scale > 16384) {
         if (this.imageSizeRadioVal === 'part_hd') {
           this.exportImgSize = [this.width * 16384 / max, this.height * 16384 / max];
           this.ii = this.jj = Math.ceil(16384 / max);
           scale = viewer.crossSectionScale.value = scale / (16384 / max);
         } else if (this.imageSizeRadioVal === 'part_hd_scale_1') {
           this.exportImgSize = [16384, 16384];
           this.ii = this.exportImgSize[0] % this.width === 0 ? this.exportImgSize[0] / this.width : Math.floor(this.exportImgSize[0] / this.width) + 1;
           this.jj = this.exportImgSize[1] % this.height === 0 ? this.exportImgSize[1] / this.height : Math.floor(this.exportImgSize[1] / this.height) + 1;
           scale = viewer.crossSectionScale.value = 1;
         }
       } else {
         if (scale > 1) {
           this.exportImgSize = [this.width * scale, this.height * scale];
           this.ii = this.jj = Math.ceil(scale);
           scale = viewer.crossSectionScale.value = 1;
         } else {
           this.exportPartImg(scale);
           return;
         }
       }

       let position = [0, 0];

       this.positionArr = [];
       this.canMove = false;
       let posLen = viewer.position.value.length;
       let rotatePosV3 = vec3.create();
       for (let j = 0; j < this.jj; j++) {
         for (let i = 0; i < this.ii; i++) {
           position[0] = oldState.position[0] + (i * this.width + this.width / 2 - this.exportImgSize[0] / 2) * scale;
           position[1] = oldState.position[1] + (j * this.height + this.height / 2 - this.exportImgSize[1] / 2) * scale;
           if (i % this.ii === 0 && j === (this.jj - 1)) {
             position[1] = oldState.position[1] - (this.height / 2 - this.exportImgSize[1] / 2) * scale;
           }
           rotatePosV3 = vec3.fromValues(position[0], position[1], 0.5);
           vec3.transformMat4(rotatePosV3, rotatePosV3, this.rotateByCurrentCenterMatrix);
           if (posLen === 3) {//兼容 position 两种长度
             this.positionArr.push(rotatePosV3);
           } else {
             this.positionArr.push(vec2.fromValues(rotatePosV3[0], rotatePosV3[1]));
           }
         }
       }
       this.unbindFn = viewer.position.changed.add(() => {
         this.handlerPositionChanged();
       })
       if (this.positionArr.length > 1) {
         this.loadingContainer.style.display = 'block';
         this.loadingEle.style.right = '100%';
       }
       this.imageName += `_${Math.floor(oldState.position[0] - this.exportImgSize[0] / 2 * scale)}_${Math.floor(oldState.position[0] + this.exportImgSize[0] / 2 * scale)}_${Math.floor(oldState.position[1] - this.exportImgSize[1] / 2 * scale)}_${Math.floor(oldState.position[1] + this.exportImgSize[1] / 2 * scale)}`;
       (<any>this.container.querySelector(".scale_num")).innerHTML = String(scale.toFixed(4));
       this.canvas.width = this.exportImgSize[0];
       this.canvas.height = this.exportImgSize[1];
       this.ctx?.clearRect(0, 0, this.exportImgSize[0], this.exportImgSize[1]);
       viewer.isBinsizeAuto.value = false;//关闭自动切换斌Size功能。导出完成后再恢复
       if (this.oldState.showScaleBar) {
         this.getScaleBarTexture();
       }
       this.viewer.showScaleBar.value = false;
       this.exportHdImage(0);
     }
   }
   getScaleBarTexture(){
     const zoom = this.exportImgSize[0]/this.panels[0].sliceView.offscreenFramebuffer.width;
     let slicePanel: SliceViewPanel = viewer.display.orderedPanels[0] as SliceViewPanel;
     viewer.display.orderedPanels.forEach((item:any)=>{
       if (item instanceof SliceViewPanel){
         slicePanel = item;
       }
     })
     const preOptions  = viewer.scaleBarOptions.value;
     const preScale  = preOptions.scaleFactor;
     preOptions.scaleFactor = zoom;
     this.scaleBarTexture = makeScaleBarTexture(slicePanel.scaleBars.scaleBars[0].dimensions,undefined,null,'',viewer.scaleBarOptions.value);
     preOptions.scaleFactor = preScale;
   }
   exportUmapImg(){
     if (this.umapPanel) {
       const curPanel = this.umapPanel;
       const umapCanvas = document.createElement('canvas');
       const umapCtx = umapCanvas.getContext('2d');
       umapCanvas.width = curPanel.sliceView.offscreenFramebuffer.width;
       umapCanvas.height = curPanel.sliceView.offscreenFramebuffer.height;
       umapCtx?.drawImage(this.viewer.display.canvas, curPanel.canvasRelativeClippedLeft, curPanel.canvasRelativeClippedTop, umapCanvas.width, umapCanvas.height, 0, 0, umapCanvas.width, umapCanvas.height);
       let customName = (<any>this.content.querySelector(".file_name")).value;
       let name = customName ? customName + '_UMAP' : 'UMAP';
       this.saveBlob(umapCanvas.toDataURL(), name);
     }
   }
   exportPartImg(scale: number) {
     if (this.imageNumRadioVal === 'all') {
       if (this.imgSrcArr.length === 3) {
         this.canvas.width = this.width * 2;
         this.canvas.height = this.height;
         this.ctx?.clearRect(0, 0, this.width * 2, this.height);
       } else if (this.imgSrcArr.length === 5) {
         this.canvas.width = this.width * 2;
         this.canvas.height = this.height * 2;
         this.ctx?.clearRect(0, 0, this.width * 2, this.height * 2);
       }
       this.exportFullLayout(0);
     } else {
       if (this.imgSrcArr.length > 1) {
         this.saveBlob(this.imgSrcArr[+this.imageNumRadioVal + 1], this.imageName + '_' + this.imageNumRadioVal);
       } else {
         if (this.isXy) {
           this.imageName += `_${Math.floor(this.oldState.position[0] - this.width / 2 * scale)}_${Math.floor(this.oldState.position[0] + this.width / 2 * scale)}_${Math.floor(this.oldState.position[1] - this.height / 2 * scale)}_${Math.floor(this.oldState.position[1] + this.height / 2 * scale)}`;
         }
         this.saveBlob(this.imgSrcArr[0], this.imageName);
       }
     }
     this.exportLegend();
     this.dispose();
   }

   //导出高清图1
   exportHdImage(i: number) {

     if (this.isQuit) return;
     this.currentIndex = i;
     this.viewer.position.value = this.positionArr[i];
     let timer1 = setInterval(() => {
       if (this.canMove) {
         clearInterval(timer1);
         this.canMove = false;
         if (i === this.positionArr.length - 1) {
           const zoom = this.exportImgSize[0]/this.panels[0].sliceView.offscreenFramebuffer.width;
           let colorBarCanvas = viewer.layout.container.updateColorScaleImg(zoom);
           if (this.colorBarCanvas && colorBarCanvas) {
             this.ctx?.drawImage(colorBarCanvas, 0, 0, colorBarCanvas.width, colorBarCanvas.height, this.exportImgSize[0] - colorBarCanvas.width - 40 * zoom, this.exportImgSize[1] - colorBarCanvas.height - 20 * zoom, colorBarCanvas.width, colorBarCanvas.height);
           }
           const scaleBarTexture =  this.scaleBarTexture;
           if (scaleBarTexture) {
             this.ctx?.drawImage(scaleBarTexture.canvas, 0, 0, scaleBarTexture.width, scaleBarTexture.height, 15 * zoom, this.exportImgSize[1] - 10 * zoom -scaleBarTexture.height, scaleBarTexture.width, scaleBarTexture.height);
           }
           let tempUrl = this.canvas.toDataURL();
           this.loadingEle.style.right = '0';
           this.loadingContainer.style.display = 'none';
           this.saveBlob(tempUrl, this.imageName);
           this.exportLegend();
          //  this.exportUmapImg();
           this.canvas.width = 0;
           this.canvas.height = 0;
           this.dispose();
         } else {
           this.loadingEle.style.right = `${(1 - ((i + 1) / this.positionArr.length)) * 100}%`;
           this.exportHdImage(++i);
         }
       }
     }, 10)
   }

   //导出Full layout时
   exportFullLayout(index: number) {
     let i = index % 2;
     let j = Math.floor(index / 2);
     this.ctx?.drawImage(this.viewer.display.canvas, this.panels[index].canvasRelativeClippedLeft, this.panels[index].canvasRelativeClippedTop, this.width, this.height, i * this.width, j * this.height, this.width, this.height);
     if (index === this.panels.length - 1) {
      html2canvas(document.querySelector(".neuroglancer-viewer-logo")!, {
        backgroundColor: null
      }).then((childCanvas:any) => {
        this.ctx?.drawImage(childCanvas, 0, 0, childCanvas.width, childCanvas.height, (this.viewer.display.canvas.width - childCanvas.width) / 2, this.viewer.display.canvas.height - childCanvas.height - 24, childCanvas.width, childCanvas.height);
        this.canvas.toBlob((blob: any) => {
          let url = window.URL.createObjectURL(blob);
          this.saveBlob(url, this.imageName);
          window.URL.revokeObjectURL(url);
        });
      })
     } else {
       this.exportFullLayout(++index);
     }
   }

   canvasToBlob(width: number, height: number, ele: HTMLCanvasElement, panel: any, callback?: any) {
     this.ctx?.clearRect(0, 0, width, height);
     this.ctx?.drawImage(ele, panel.canvasRelativeClippedLeft, panel.canvasRelativeClippedTop, width, height, 0, 0, width, height);

     let commonFn = () => {
       this.canvas.toBlob((blob: any) => {
         this.imgSrcArr.push(window.URL.createObjectURL(blob));
         if (!this.imgDom.src) this.imgDom.src = this.imgSrcArr[0];
         if (callback) callback();
       });
     }
     if (this.hasColorBar) {
       html2canvas(document.querySelector(".neuroglancer-viewer-scalebar")!, {
         backgroundColor: null
       }).then((canvas:any) => {
         this.colorBarCanvas = canvas;
         this.ctx?.drawImage(canvas, 0, 0, canvas.width, canvas.height, width - canvas.width - 40, height - canvas.height - 20, canvas.width, canvas.height);
         html2canvas(document.querySelector(".neuroglancer-viewer-logo")!, {
          backgroundColor: null
        }).then((childCanvas:any) => {
          this.ctx?.drawImage(childCanvas, 0, 0, childCanvas.width, childCanvas.height, (width - childCanvas.width) / 2, height - childCanvas.height - 24, childCanvas.width, childCanvas.height);
          commonFn();
        })
       })
     } else {
      html2canvas(document.querySelector(".neuroglancer-viewer-logo")!, {
        backgroundColor: null
      }).then((childCanvas:any) => {
        this.ctx?.drawImage(childCanvas, 0, 0, childCanvas.width, childCanvas.height, (width - childCanvas.width) / 2, height - childCanvas.height - 24, childCanvas.width, childCanvas.height);
        commonFn();
      })
     }
   }

   // 初始化DOM
   initDom() {
     this.content.classList.add('export_image_container');
     this.loadingContainer.className = 'loading_container';
     this.loadingContainer.innerHTML = `
        <div class="progress">
          <p>${i18n.exportPanelSize}<span class="scale_num"></span><br/>${i18n.exportPanelTakeTime}</p>
        </div>
        `;
     this.loadingContainer.getElementsByClassName('progress')[0].appendChild(this.loadingEle);
     this.a.style.display = 'none';
     document.body.appendChild(this.a);
    //  let radioStr: string = "";
    //  if (this.panels.length > 1) {
    //    radioStr += `
    //       <div>
    //         <input type="radio" name="export_number" value="all"/>
    //         <label>Full layout</label>
    //       </div>
    //     `;
    //  };
    //  this.panels.forEach((val, i) => {
    //    if (val instanceof SliceViewPanel) {
    //      radioStr += `
    //         <div>
    //           <input type="radio" name="export_number" value="${i}"/>
    //           <label>Panel ${i + 1} View</label>
    //         </div>
    //       `;
    //    } else {
    //      radioStr += `
    //         <div>
    //           <input type="radio" name="export_number" value="${i}" />
    //           <label>3D View</label>
    //         </div>
    //       `;
    //    }
    //  });
     let tempStr: string = (this.isXy || this.umapPanel)? "" : "disabled";
    //  this.content.innerHTML += `
    //     <h3>Screenshot</h3>
    //     <div class="container">
    //       <div class="row">
    //         <span>File name:</span>
    //         <input type="text" class="file_name" placeholder="custom file name">
    //       </div>
    //       <div class="row img_container">
    //         <span>Image number:</span>
    //         <div>${radioStr}</div>
    //       </div>
    //       <div class="row">
    //         <span>Image size:</span>
    //         <div>
    //           <div>
    //             <input type="radio" name="export_size" value="part"/>
    //             <label>Current window image</label>
    //           </div>
    //           <div>
    //             <input type="radio" name="export_size" value="part_hd"/ ${tempStr}>
    //             <label>Current window HD image(Complete image, but scale parameter may not set to 1)</label>
    //           </div>
    //           <div>
    //             <input type="radio" name="export_size" value="part_hd_scale_1"/ ${tempStr}>
    //             <label>Current window HD image(Scale parameter set to 1, may cause incomplete image)</label>
    //           </div>
    //         </div>
    //       </div>
    //     </div>
    //     <div class="footer">
    //       <button class="export_image_btn">EXPORT IMAGE</button>
    //     </div>
    //   `;
    this.content.innerHTML += `
    <h3 style="text-align: center">${i18n.exportPanelDownload}</h3>
    <div class="container">
      <div class="row">
        <span>${i18n.exportPanelFilename}</span>
        <input type="text" class="file_name" placeholder=${i18n.exportPanelFilenamePlace}>
      </div>
      <div class="row">
        <span>${i18n.exportPanelImagesize}</span>
        <div>
          <div>
            <input type="radio" name="export_size" value="part"/>
            <label>${i18n.exportPanelScreenshot}</label>
          </div>
          <div>
            <input type="radio" name="export_size" value="part_hd"/ ${tempStr}>
            <label>${i18n.exportPanelHD}</label>
          </div>
        </div>
      </div>
    </div>
    <div class="footer">
      <button class="export_image_btn">${i18n.exportPanelExport}</button>
    </div>
  `;
     this.loadingContainer.style.display = 'none';
     this.content.appendChild(this.loadingContainer);
     this.content.getElementsByClassName("container")[0].appendChild(this.imgDom);
   }

   handlerPositionChanged() {
     let timer2 = setInterval(() => {
       if (this.viewer.isCompleted()) {
         clearInterval(timer2);
         setTimeout(() => {
           this.getImg();
         }, 30);
       }
     }, 10);
   }

   getImg() {
     let _this = this;
     let index = this.currentIndex;
     let i = index % this.ii;
     let j = Math.floor(index / this.ii);
     let left = this.panels[0].canvasRelativeClippedLeft;
     let top = this.panels[0].canvasRelativeClippedTop;

     let tempUrl = this.viewer.display.canvas.toDataURL();
     let p3 = new Image();
     p3.src = tempUrl;
     p3.onload = function () {
       if (index % _this.ii === 0 && Math.floor(index / _this.ii) === (_this.jj - 1)) {
         _this.ctx?.drawImage(this as any, left, top, _this.width, _this.height, 0, _this.exportImgSize[1] - _this.height, _this.width, _this.height);
       } else {
         _this.ctx?.drawImage(this as any, left, top, _this.width, _this.height, i * _this.width, j * _this.height, _this.width, _this.height);
       }
       _this.canMove = true;
     }
   }

   //导出图例
   exportLegend() {
     if (this.hasLegend) {
       let tempEle: HTMLElement = document.querySelector(".neuroglancer-viewer-legend-item")!;
       tempEle.classList.add('auto-height');
       let hasMoreLengend = document.querySelector(".neuroglancer-viewer-legend-item .selecte-views-label");
                html2canvas(tempEle, {
                  backgroundColor: null
       }).then((canvas) => {
         let customName = (<any>this.content.querySelector(".file_name")).value;
         console.log(hasMoreLengend)
         if (hasMoreLengend) {
          let time = new Date().getTime();
          let name = customName ? customName + `_legend1_${time}` : `legend1_${time}`;
          this.saveBlob(canvas.toDataURL(), name);

          let currentLengendName = tempEle.querySelector(".selecte-text")?.innerHTML || '';
          let currentLengendLi: any;

          tempEle.querySelectorAll(".el-select-dropdown__list li").forEach((item: any) => {
            console.log(222)
            if (item.innerHTML.includes(currentLengendName)) {
              currentLengendLi = item;
            } else {
              item.click();
              item.click();
              setTimeout(() => {
                html2canvas(tempEle, {
                  backgroundColor: null
                }).then((canvas) => {
                  let name = customName ? customName + `_legend2_${time}` : `legend2_${time}`;
                  this.saveBlob(canvas.toDataURL(), name);
                  tempEle.classList.remove("auto-height");
                  currentLengendLi.click();
                  currentLengendLi.click();
                })
              }, 300);
            }
          })

         } else {
          let name = customName ? customName + `_legend1` : `legend1`;
          this.saveBlob(canvas.toDataURL(), name);
          tempEle.classList.remove("auto-height")
         }
       })
     }
   }

   dispose() {
     this.isQuit = true;
     viewer.isBinsizeAuto.value = this.preIsBinsizeAuto;//导出高清图完成后恢复
     setTimeout(() => {
       if (this.unbindFn) this.unbindFn();
       this.viewer.position.restoreState(this.oldState.position);
       this.viewer.crossSectionScale.restoreState(this.oldState.crossSectionScale);
       this.viewer.showScaleBar.value = this.oldState.showScaleBar;
       this.imgSrcArr.forEach(val => {
         window.URL.revokeObjectURL(val);
       });
       (<any>document.querySelector("#neuroglancer-container")).className = "";
       document.body.removeChild(this.a);
       super.dispose();
     }, 30);
   }
 }
